export const COMPANY = {
  name: "Redwood Capital Holdings, Inc.",
  shortName: "Redwood Capital Holdings",
  location: "Charlotte, North Carolina",
  tagline: "Building Value. Creating Opportunities.",
  phone: "+1 (704) 666 3136",
  phoneHref: "tel:+17046663136",
  email: "info@redwoodcaphold.com",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "What We Buy", to: "/what-we-buy" },
  { label: "Development", to: "/development" },
  { label: "Investment Opportunities", to: "/investment-opportunities" },
  { label: "Brokers & Partners", to: "/brokers-partners" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroHome:
    "https://images.unsplash.com/photo-1772325482422-55bc8dd65662?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxyZXNpZGVudGlhbCUyMGxhbmQlMjBkZXZlbG9wbWVudCUyMGFlcmlhbHxlbnwwfHx8fDE3ODY2NTIzMTF8MA&ixlib=rb-4.1.0&q=85",
  forest:
    "https://images.unsplash.com/photo-1578347604204-a5ae063847e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxwaW5lJTIwZm9yZXN0JTIwYWVyaWFsfGVufDB8fHx8MTc4NjY1MjMyNXww&ixlib=rb-4.1.0&q=85",
  meeting:
    "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb3Jwb3JhdGUlMjBpbnZlc3RtZW50JTIwbWVldGluZ3xlbnwwfHx8fDE3ODY2NTIzMTF8MA&ixlib=rb-4.1.0&q=85",
  blueprint:
    "https://images.unsplash.com/photo-1721244654392-9c912a6eb236?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwYmx1ZXByaW50JTIwZHJhd2luZ3xlbnwwfHx8fDE3ODY2NTIzMjV8MA&ixlib=rb-4.1.0&q=85",
  skyline:
    "https://images.unsplash.com/photo-1612911853182-96e6be2792c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxjaXR5JTIwc2t5bGluZSUyMGFlcmlhbCUyMGRheXxlbnwwfHx8fDE3ODY2NTIzMjV8MA&ixlib=rb-4.1.0&q=85",
};

export const MARKETS = [
  "Charlotte",
  "Union County",
  "Mecklenburg County",
  "Waxhaw",
  "Marvin",
  "Weddington",
  "Wesley Chapel",
  "Indian Trail",
  "Matthews",
];

export const INVESTMENT_FOCUS = [
  { title: "Residential Development Land", desc: "Well-located parcels positioned for residential growth." },
  { title: "Single-Family Development", desc: "Sites suited for single-family communities and lots." },
  { title: "Infill Opportunities", desc: "Underutilized parcels within established areas." },
  { title: "Large Residential Parcels", desc: "Acreage with scale for master-planned potential." },
  { title: "Farms with Development Potential", desc: "Agricultural land in the path of growth." },
  { title: "Estate & Inherited Properties", desc: "Legacy holdings ready for a new chapter." },
  { title: "Assemblage Opportunities", desc: "Adjacent parcels that create combined value." },
  { title: "Off-Market Properties", desc: "Opportunities before they reach the broader market." },
];

export const WHAT_WE_DO = [
  {
    icon: "MapTrifold",
    title: "Land Acquisition",
    desc: "We identify strategically located land with strong residential development potential.",
  },
  {
    icon: "Buildings",
    title: "Residential Development",
    desc: "We evaluate and develop residential opportunities based on market demand, infrastructure, zoning, and long-term value.",
  },
  {
    icon: "Handshake",
    title: "Investment Partnerships",
    desc: "We work with investors and strategic partners to pursue attractive real estate opportunities.",
  },
  {
    icon: "Compass",
    title: "Off-Market Opportunities",
    desc: "We work directly with property owners, brokers, and local professionals to identify opportunities before they reach the broader market.",
  },
];

export const WHY_REDWOOD = [
  {
    icon: "Compass",
    title: "Local Market Knowledge",
    desc: "Understanding Charlotte-area growth, zoning, infrastructure, and development trends.",
  },
  {
    icon: "ChartLineUp",
    title: "Disciplined Analysis",
    desc: "Every opportunity is evaluated based on development feasibility, market demand, cost, risk, and potential return.",
  },
  {
    icon: "UsersThree",
    title: "Strong Partnerships",
    desc: "We collaborate with landowners, brokers, engineers, builders, consultants, and investors.",
  },
  {
    icon: "TreeEvergreen",
    title: "Long-Term Value Creation",
    desc: "Our objective is to transform well-located real estate into valuable residential communities and investment opportunities.",
  },
];

export const DEV_PROCESS = [
  { n: "01", title: "Identify", desc: "Find strategically located opportunities." },
  { n: "02", title: "Evaluate", desc: "Review zoning, utilities, access, market conditions, environmental constraints, and development feasibility." },
  { n: "03", title: "Structure", desc: "Determine acquisition, investment, and development strategy." },
  { n: "04", title: "Entitle", desc: "Work with engineers, planners, municipalities, and consultants through zoning and entitlement processes." },
  { n: "05", title: "Develop", desc: "Prepare the property for residential development." },
  { n: "06", title: "Create Value", desc: "Execute the strategy through development, builder partnerships, lot sales, or completed projects." },
];
